// Shared by browser controls and server receipt validation. An empty sequence
// never grants completion, and only the first pending item may be confirmed.
export function confirmationSequence<Item>(items: readonly Item[], isConfirmed: (item: Item) => boolean) {
  const pendingIndex = items.findIndex(item => !isConfirmed(item));
  return {
    complete: items.length > 0 && pendingIndex === -1,
    next: pendingIndex === -1 ? undefined : items[pendingIndex],
    isUnlocked: (index: number) => Number.isInteger(index) && index >= 0 && index < items.length
      && (pendingIndex === -1 || index <= pendingIndex),
  };
}

export function updateOrderedConfirmation<Key extends string, Value>(
  keys: readonly Key[],
  choices: Record<Key, Value>,
  key: Key,
  value: Value,
  clearedValue: Value,
  isAccepted: (key: Key, value: Value) => boolean,
): Record<Key, Value> {
  const index = keys.indexOf(key);
  if (!confirmationSequence(keys, item => isAccepted(item, choices[item])).isUnlocked(index)) return choices;
  const next = { ...choices };
  next[key] = value;
  if (!isAccepted(key, value)) {
    for (const later of keys.slice(index + 1)) next[later] = clearedValue;
  }
  return next;
}
